"use client";
import { useState, useEffect } from "react";

import { STICKY_HEADER_REF } from "@stadium/ui/src/components/header";

const useHeaderHeight = (initialValue) => {
  const [headerHeight, setHeaderHeight] = useState(
    STICKY_HEADER_REF?.current?.clientHeight ?? initialValue,
  );

  useEffect(() => {
    if (!STICKY_HEADER_REF.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      if (entries[0]) {
        setHeaderHeight(entries[0].contentRect.height);
      }
    });

    resizeObserver.observe(STICKY_HEADER_REF.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return headerHeight;
};

export default useHeaderHeight;
